"use client";

import { useToolbarItem } from "../__chunks/45NMHJPK.js";
import "../__chunks/NSB34BGG.js";
import "../__chunks/SZHY72KI.js";
import "../__chunks/ZHUQ44XA.js";
import "../__chunks/5VQZOHHZ.js";
import { useToolbarContext } from "../__chunks/LDHO2NSJ.js";
import "../__chunks/APGXEJ2Q.js";
import "../__chunks/G4PVPWEW.js";
import "../__chunks/Z4WWVOIF.js";
import "../__chunks/SWN3JYXT.js";
import { createElement, createHook, forwardRef, memo } from "../__chunks/7FZLUSKW.js";
import "../__chunks/CTKPPFRS.js";
import "../__chunks/HNHAUIIY.js";
import "../__chunks/SK3NAZA3.js";
import { __objRest, __spreadValues } from "../__chunks/3YLGPPWQ.js";

// src/toolbar/toolbar-input.tsx
var TagName = "input";
var useToolbarInput = createHook(function useToolbarInput2(_a) {
  var _b = _a,
    store = _b.store,
    props = __objRest(_b, ["store"]);
  var context = useToolbarContext();
  store = store || context;
  props = useToolbarItem(__spreadValues({
    store: store
  }, props));
  return props;
});
var ToolbarInput = memo(forwardRef(function ToolbarInput2(props) {
  var htmlProps = useToolbarInput(props);
  return createElement(TagName, htmlProps);
}));
export { ToolbarInput, useToolbarInput };